/**
 * BrewLoader — the Breww mark itself, animated while an assistant reply is being
 * generated. A highlight sweeps top→bottom over the logo (masked to its own
 * shape) as if the answer is brewing, and the mark gently breathes.
 *
 * Motion is pure CSS (keyframes in styles.css under `.brew-logo-loader`) — there
 * is nothing to start/stop imperatively. Pass `idle` to hold it static (the
 * plain Breww mark) — used once the reply has landed and it just sits beside the
 * copy button; omit it while the turn is streaming to keep the reveal running.
 */
export function BrewLoader({ size = 30, idle = false }: { size?: number; idle?: boolean }): JSX.Element {
  return (
    <span
      className={`brew-logo-loader${idle ? ' is-idle' : ''}`}
      style={{ width: size, height: size }}
      role={idle ? undefined : 'status'}
      aria-label={idle ? 'Breww' : 'Generating a response'}
      aria-hidden={idle ? true : undefined}
    />
  );
}
